module.exports = __webpack_public_path__ + "media/entities/5203-bd26bf12.png";